<template>
  <v-card class="is-clickable pa-3 mb-4" flat @click="openEditDoctorDialog">
    <v-row no-gutters align="center">
      <v-col class="col-12 col-sm-auto">
        <v-icon class="mr-4" color="primary" large>fas fa-user-circle</v-icon>
      </v-col>
      <v-col class="flex-grow-1">
        <span class="body-2 font-weight-bold secondary--text">
          {{ doctorServiceItem.doctor.surname }}
        </span>
        <span class="body-2 font-weight-bold"
          >{{ doctorServiceItem.doctor.name }}
        </span>
        <div class="service-list">
          <v-tooltip
            v-for="(service, i) in getAllServices"
            :key="i"
            class="service-item"
            color="primary"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-chip
                class="service-chip text-uppercase my-1 mr-1"
                color="primary"
                v-on="on"
                small
                ><span class="font-weight-bold text-truncate">
                  {{ service.nameByLang }}
                </span></v-chip
              >
            </template>
            <span class="font-weight-bold text-uppercase caption">{{
              service.nameByLang
            }}</span>
          </v-tooltip>
        </div>
        <span v-if="getAllServices.length <= 0">
          <span class="font-italic">{{
            $t("hfManagement.noAvailableService")
          }}</span>
        </span>
      </v-col>
      <v-col class="col-12 col-sm-auto">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          outlined
          rounded
          small
          ><span v-if="hasWritePerm">{{ $t("hfManagement.edit") }}</span>
          <span v-else>{{ $t("hfManagement.view") }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import split from "lodash/split";

export default {
  props: {
    doctorServiceItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasWritePerm() {
      return this.$store.getters["auth/userHasRequiredAccess"](
        "GESTIONESTRUTTURASANITARIA",
        "READWRITE"
      );
    },
    getAllServices() {
      return this.doctorServiceItem?.serviceList || [];
    }
  },
  methods: {
    redirectToEditDoctor(doctorId) {
      if (!this.hasWritePerm) return;
      this.$router.push({ name: "hfEditDoctor", params: { id: doctorId } });
    },
    openEditDoctorDialog() {
      this.$emit("openeditdoctordialog", this.doctorServiceItem);
    }
  }
};
</script>

<style scoped>
.service-list >>> .service-chip .v-chip__content {
  max-width: 380px;
}
</style>
